import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';

// Rename the name of the function:
const ProposalPdfLayoutForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    // Prefill the division with the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionDefaultValue = !isEnvironmentSelected && selectedDivision ? { value: String(selectedDivision.id) } : undefined;

    // Set the api object
    const apiObject = 'layout'

    // Set the linked item
    const linkedItem = { 
        connected_feature: 'proposal',  
        layout_type: 'pdf'
    }

    // Set the redirect to after saving the item
    const redirectTo = {
        url: 'settings/templates/layout/pdf-layout',
        itemIdField: 'id'
    }

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        { 
            type: 'radio', 
            name: 'layout_type',
            label: 'layout.general.layout_type_label',
            dependentOn: { fieldName: '', value: [''] }, // Hacky solution to hide field in the form
            defaultValue: 'pdf', 
            options: [
                { value: 'pdf', name: 'layout.general.layout_type_pdf_label'},
            ],
        },
        {
            name: 'name',
            label: 'layout.general.name_label',
            type: 'text',
            placeholder: 'layout.general.name_placeholder',
        },
        {
            name: 'division',
            defaultValue: divisionDefaultValue,
            label: 'layout.general.division_label',
            type: 'dropdown',
            disabled_selected: 'layout.general.division_disabled_selected',
            showSearch: false,
            apiRequest: [{
                endpoint: 'get_division_list',
                object: 'division',
                params: { is_active: true },
                useCache: true
            }],
            allowNoneOption: false,
            activeFeature: 'divisions'
        },
        { 
            type: 'dropdown', 
            name: 'connected_feature', 
            dependentOn: [
               { fieldName: 'layout_type', value: 'pdf' },
               { fieldName: '', value: [''] }, // Hacky solution to hide field in the form
            ],
            label: 'layout.general.connected_feature_label',
            disabled_selected: 'forms.select_type_disabled_selected',
            defaultValue: { value: 'proposal' },
            allowNoneOption: false,
            showSearch: false,
            hardcodedOptions: ([
                { value: 'proposal', name: 'layout.connected_feature.proposal', requiredFeature: 'proposals' },
            ]),
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={linkedItem}
            redirectTo={redirectTo}
        />
    );
};

export default ProposalPdfLayoutForm;